module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-3x4-9c3535a792f03d990f317e88fa40cdfc.jpg";